import React from 'react';
import { Link } from 'react-router-dom';
import { Globe } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="border-t border-slate-200 bg-slate-50" data-testid="main-footer">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-10">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-8">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-3">
              <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-sky-500 to-blue-600 flex items-center justify-center">
                <Globe className="w-4 h-4 text-white" />
              </div>
              <span className="font-semibold text-slate-900" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
                Domain-Preischeck
              </span>
            </div>
            <p className="text-sm text-slate-500 leading-relaxed">
              Der faire Domain-Preisvergleich. Wir vergleichen die Preise aller großen Anbieter – transparent,
              aktuell und ohne Sternchen.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h3 className="text-sm font-semibold text-slate-900 mb-3">Navigation</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/" className="text-slate-500 hover:text-sky-600">Startseite</Link></li>
              <li><Link to="/anbieter" className="text-slate-500 hover:text-sky-600">Anbieter</Link></li>
              <li><Link to="/ratgeber" className="text-slate-500 hover:text-sky-600">Domain-Kauf-Ratgeber</Link></li>
              <li><Link to="/domain-technik" className="text-slate-500 hover:text-sky-600">Domain-Technik</Link></li>
              <li><Link to="/kontakt" className="text-slate-500 hover:text-sky-600">Kontakt</Link></li>
            </ul>
          </div>

          {/* Provider */}
          <div>
            <h3 className="text-sm font-semibold text-slate-900 mb-3">Für Anbieter</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/ueber-uns" className="text-slate-500 hover:text-sky-600">Über uns</Link></li>
              <li><Link to="/fuer-provider" className="text-slate-500 hover:text-sky-600">Für Provider</Link></li>
              <li><Link to="/impressum" className="text-slate-500 hover:text-sky-600">Impressum &amp; Datenschutz</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-slate-200 text-xs text-slate-400">
          © {new Date().getFullYear()} Domain-Preisvergleich.de · Preise können abweichen · Stand der Preise wird
          je Anbieter angezeigt
        </div>
      </div>
    </footer>
  );
}
